import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
  Tooltip,
  CircularProgress,
  TextareaAutosize,
} from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React, { useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { convertBase64, getUserData } from "../../../Base/helper/baseFunctions";
import { UploadTaxDeclarationProofHelper } from "../../helper/TaxDeclarationHelper";
import CancelIcon from "@mui/icons-material/Cancel";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const TDStep2 = ({
  handleInputChange,
  step2,
  setStep2,
  stepUpdate2,
  setStepUpdate2,
  activeStep,
  setActiveStep,
  disableEdit = false,
  toggleState,
  toggleDeclarationState,
  checkViewType,
  defaultValue,
  comments,
  setComments,
  fileProof,
  setFileProof,
  handleView,
  checkDeclarationStatus,
}) => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      paper: {
        boxShadow:
          "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "10px 20px",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        justifyContent: "space-between",
        width: "100%",
      },
    })
  );
  const classes = useStyles();
  const headerTypographyStyle = {
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "14px",
    color: "black",
  };
  // const fields = [
  //   { name: "et_80d_sec80d", desc: "Self, Children, Spouse", label: "" },
  //   { name: "et_80dp_sec80dp", desc: "Parents", label: "" },
  //   { name: "et_80d_md", desc: "Max Deduction", label: "" },
  //   {
  //     name: "et_80d_ph",
  //     desc: "Preventive Healthcare",
  //     label: "",
  //   },
  // ];
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedRow, setSelectedRow] = useState(null);
  const [errors, setErrors] = useState({});
  const handleMenuClick = (event, rowKey) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowKey);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const fields = [
    {
      name: "et_80ccd_1b_nps",
      desc: "National Pension Scheme (upto Rs.50000/-)",
      label: "80CCD(1B) - NPS",
    },
    {
      name: "et_80d_sec80d",
      desc: "Mediclaim Policy Premium (For Self, spouse & children). Below 60 years - Rs. 25000/- (Including amount paid for Preventive health check-up Rs.5000/-)",
      label: "80D - SEC80D",
    },
    {
      name: "et_80ds_sec80ds",
      desc: "Mediclaim Policy Premium (For Self, spouse & children). Above 60 years - Rs. 50000/- (Including amount paid for Preventive health check-up Rs.5000/-)",
      label: "80DS - SEC80DS",
    },
    {
      name: "et_80dp_sec80dp",
      desc: "Mediclaim Policy Premium (For Dependent Parents). Below 60 years - Rs. 25000/- (Including amount paid for Preventive health check-up Rs.5000/-)",
      label: "80DP - SEC80DP",
    },
    {
      name: "et_80dps_sec80dps",
      desc: "Mediclaim Policy Premium (For Dependent Parents). Above 60 years - Rs. 50000/- (Including amount paid for Preventive health check-up Rs.5000/-)",
      label: "80DPS - SEC80DPS",
    },
    {
      name: "et_80ddp_sec80ddb",
      desc: "Treatment of specified diseases for self/dependents - Below 60 years - Actual Expenditure upto Rs.40000/- reduced by insurance claims",
      label: "80DDB - SEC80DDB",
    },
    {
      name: "et_80ddbs_sec80ddbs",
      desc: "Treatment of specified diseases for self/dependents - Above 60 years - Actual Expenditure upto Rs.100000/- reduced by insurance claims",
      label: "80DDBS - SEC80DDBS",
    },
    {
      name: "et_80e_sec80e",
      desc: "Payment of interest on loan taken for higher education for a full time course - Without any limit (Self/Spouse/Children)",
      label: "80E - SEC80E",
    },
    {
      name: "et_80dd_sec80dd",
      desc: "Medical Treatment of handicapped dependent (Dependents) - Rs.75000/Rs.125000/-",
      label: "80DD - SEC80DD",
    },
    {
      name: "et_80u_sec80u",
      desc: "Deductions in case of self being totally blind or physically handicapped - Rs.75000/Rs.125000/-",
      label: "80U - SEC80U",
    },
    {
      name: "et_80eeb_sec80eeb",
      desc: "Interest on loan taken for purchase of Electric Vehicle (Upto Rs.150000/-)",
      label: "80EEB - SEC80EEB",
    },
    {
      name: "et_80ggc_sec80ggc",
      desc: "Deduction in respect of contributions given to political parties.",
      label: "80GGC - SEC80GGC",
    },
  ];
  const maxLimits = {
    et_80ccd_1b_nps: 50000,
    et_80d_sec80d: 25000,
    et_80ds_sec80ds: 50000,
    et_80dp_sec80dp: 25000,
    et_80dps_sec80dps: 50000,
    et_80ddp_sec80ddb: 40000,
    et_80ddbs_sec80ddbs: 100000,
    et_80e_sec80e: Infinity,
    et_80dd_sec80dd: 125000,
    et_80u_sec80u: 125000,
    et_80eeb_sec80eeb: 150000,
    et_80ggc_sec80ggc: Infinity,
  };
const validate = (fieldValues, maxLimits) => {
  let temp = { ...errors };

  Object.keys(fieldValues).forEach((field) => {
    const value = Number(fieldValues[field]);
    const max = maxLimits[field] ?? Infinity;

    if (field in maxLimits) {
       if (value > max) {
        temp[field] = `Limit: ₹${max.toLocaleString()}`;
      } else {
        temp[field] = "";
      }
    }
  });

  setErrors(temp);

  // return true if all errors are empty
  return Object.values(temp).every((x) => x === "");
};


  const [uploadStatus, setUploadStatus] = useState({});
  const [files, setFiles] = useState([]);
  const { show, disable_ap } = checkDeclarationStatus || {};

  const handleChange = (e) => {
    const { name, value } = e.target;
    const rawValue = value.replace(/,/g, "");

    if (rawValue === "" ||  /^\d*\.?\d*$/.test(rawValue)) {
      setStep2({ ...step2, [name]: +rawValue });

      if (Object.values(errors).some((x) => x !== "")) {
        validate({ [name]: rawValue }, maxLimits);
      }
    }
  };

  const handleUpdateChange = (e) => {
    const { name, value } = e.target;
    const rawValue = value.replace(/,/g, "");
    if (rawValue === "" ||  /^\d*\.?\d*$/.test(rawValue)) {
      setStepUpdate2({ ...stepUpdate2, [name]: +rawValue });
    }
  };
  const handleSubmit = () => {
    if (!checkViewType) {
       const isValid = validate(step2, maxLimits);
       if (!isValid) return;
       setActiveStep(activeStep + 1);
      } else {
       setActiveStep(activeStep + 1);
     }
    handleInputChange({ target: { name: "tds2", value: step2 } });
  };

  const calculateTotal = () => {
    return Object.values(step2).reduce(
      (acc, value) => acc + (parseFloat(value) || 0),
      0
    );
  };
  const calculateTotal2 = () => {
    return Object.values(stepUpdate2).reduce(
      (acc, value) => acc + (parseFloat(value) || 0),
      0
    );
  };

  const handleFileUpload = async (event, name) => {
    const userData = getUserData();
    const file = event.target.files[0];
    if (file) {
      try {
        const allowedMimeTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];
        if (!allowedMimeTypes.includes(file.type)) {
          toast.error(
            "Invalid File type. Accepted file types: .pdf, .doc, .docx",
            {
              duration: 2000,
            }
          );
          return;
        }
        const b64string = await convertBase64(file);
        const ext = file?.name?.split(".").at(-1).toLowerCase();
        const content_type = file.type;
        const filename =
          `${userData?.domain}/Payroll/EmployeeTDProof/` +
          uuidv4() +
          "." +
          name +
          "." +
          ext;
        setFiles((prev) => [
          ...prev,
          {
            b64string,
            filename,
            content_type,
            td_component: name,
          },
        ]);
        setUploadStatus((prev) => ({
          ...prev,
          [name]: "uploaded",
        }));
      } catch (error) {
        console.error("Error during file upload: ", error);
      }
    }
  };
  const handleDeselectFile = (name) => {
    setFiles((prev) => prev.filter((file) => file.td_component !== name));
    setUploadStatus((prev) => ({
      ...prev,
      [name]: null,
    }));
  };

  const handleSaveDocs = async (name, files) => {
    const fileToSave = files.find((file) => file?.td_component === name);
    setUploadStatus((prev) => ({
      ...prev,
      [name]: "loading",
    }));
    if (fileToSave) {
      try {
        const res = await UploadTaxDeclarationProofHelper({
          ...fileToSave,
          old_file_path: fileProof[fileToSave?.td_component],
        });

        if (res?.data?.statuscode === 200) {
          setFileProof((prev) => ({
            ...prev,
            [fileToSave?.td_component]: res?.data?.data?.[0]?.cloud_file,
          }));
        }
      } finally {
        setUploadStatus((prev) => ({
          ...prev,
          [name]: null,
        }));
        setFiles((prev) => prev.filter((file) => file.td_component !== name));
      }
    } else {
      setUploadStatus((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  return (
    <Box>
      <Typography variant="h6">
        Other Chapter VIA - Maximum Eligible deduction as per Section Limits
      </Typography>
      {/* Header Row */}
      {(checkViewType || show) && (
        <Grid
          container
          width={"100%"}
          sx={{ padding: "4px 8px", marginBottom: "4px" }}
        >
          <Box
            sx={{
              width: "98%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
              textAlign: "center",
            }}
          >
            <Box width={"60%"} pr={1}>
              <Typography sx={headerTypographyStyle}></Typography>
            </Box>
            <Box width={"15%"}>
              <Typography sx={headerTypographyStyle}>Declared</Typography>
            </Box>
            {(checkViewType || show) && (
              <Box width={"15%"}>
                <Typography sx={{ ...headerTypographyStyle, ml: "-15px" }}>
                  Approved
                </Typography>
              </Box>
            )}
            <Box width={"10%"} display="flex" justifyContent="space-around">
              <Typography sx={headerTypographyStyle}>Preview Proof</Typography>
            </Box>
            <Box width={"30%"}>
              <Typography sx={{ ...headerTypographyStyle, ml: "-20px" }}>
                Comment
              </Typography>
            </Box>
          </Box>
        </Grid>
      )}
      <Grid container>
        {fields.map((data, id) => {
          return (
            <>
              {!disableEdit ? (
                <Grid
                  item
                  key={id}
                  width={"100%"}
                  sx={{ padding: "4px 8px", marginBottom: "4px" }}
                >
                  <Paper className={classes.paper}>
                    <Box width={"60%"}>
                      <Typography variant="h6" color={"inherit"}>
                        {data?.label}
                      </Typography>
                      <Typography variant="body2" color={"inherit"}>
                        {data?.desc}
                      </Typography>
                    </Box>
                    {/* Declaration Field */}
                    <Box width={"15%"}>
                      <TextField
                        size="small"
                        disabled={
                          toggleDeclarationState || checkViewType || disable_ap
                        }
                        autoComplete="first_name"
                        onChange={handleChange}
                        name={data?.name}
                        label={data?.label}
                        placeholder="Enter Amount"
                        fullWidth
                        value={ step2?.[data?.name] ? Number(step2?.[data?.name]).toLocaleString("en-IN") : ""}
                        type="text"
                        onWheel={(e) => e.target.blur()}
                        sx={{
                          backgroundColor:
                            toggleDeclarationState ||
                            checkViewType ||
                            disable_ap
                              ? "transparent"
                              : "#ffffff",
                          borderRadius: "10px",
                          "& input::placeholder": {
                            fontSize: "10px",
                            color: "#aaa",
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: "12px",
                          },
                        }}
                      />
                       {errors[data?.name] && (
                        <Typography
                          variant="caption"
                          color="error"
                          sx={{ mt: "4px", fontSize: "10px", ml: "2px" }}
                        >
                          {errors[data?.name]}
                        </Typography>
                      )}
                    </Box>
                    {/* Approved Field */}
                    {(checkViewType || show) && (
                      <Box width={"15%"} borderRadius={"10px"}>
                        <TextField
                          size="small"
                          type="text"
                          disabled={!checkViewType}
                          autoComplete="first_name"
                          onChange={handleUpdateChange}
                          name={`${data?.name}_approved`}
                          label={data?.label}
                          placeholder="Enter Amount"
                          fullWidth
                          value={stepUpdate2?.[`${data?.name}_approved`] ? Number(stepUpdate2?.[`${data?.name}_approved`]).toLocaleString("en-IN") : ""}
                          onWheel={(e) => e.target.blur()}
                          sx={{
                            backgroundColor: !checkViewType
                              ? "transparent"
                              : "#ffffff",
                            borderRadius: "10px",
                            "& input::placeholder": {
                              fontSize: "12px",
                              color: "#aaa",
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: "12px",
                            },
                          }}
                        />
                      </Box>
                    )}
                    <Box
                      width={"10%"}
                      display="flex"
                      justifyContent={"space-around"}
                      alignItems={"center"}
                    >
                      <IconButton
                        aria-label="actions"
                        aria-controls={open ? "proof-actions-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={(e) => handleMenuClick(e, data?.name)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        id="proof-actions-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        MenuListProps={{
                          "aria-labelledby": "actions-button",
                        }}
                        sx={{
                          "& .MuiPaper-root": {
                            boxShadow: "none",
                          },
                        }}
                      >
                        <MenuItem>
                          {!checkViewType && (
                            <>
                              {!uploadStatus[selectedRow] && (
                                <Tooltip
                                  title={
                                    !toggleState
                                      ? "Proof upload window disabled"
                                      : "Proof Upload"
                                  }
                                >
                                  <Box
                                    display={"flex"}
                                    ml={"-8px"}
                                    alignItems={"center"}
                                  >
                                    <IconButton
                                      color="primary"
                                      component="label"
                                      disabled={
                                        !toggleState ||
                                        uploadStatus[selectedRow] === "uploaded"
                                      }
                                      sx={{
                                        "&:hover": {
                                          backgroundColor: "transparent", // remove hover background
                                        },
                                      }}
                                    >
                                      <CloudUploadIcon sx={{ mr: 1.5 }} />
                                      <Typography sx={{ fontSize: "0.9rem" }}>
                                        Proof Upload
                                      </Typography>
                                      <input
                                        type="file"
                                        hidden
                                        onChange={(event) =>
                                          handleFileUpload(event, selectedRow)
                                        }
                                      />
                                    </IconButton>
                                  </Box>
                                </Tooltip>
                              )}

                              {uploadStatus[selectedRow] === "loading" ? (
                                <CircularProgress
                                  size={24}
                                  sx={{ display: "block", margin: "0 auto" }}
                                />
                              ) : uploadStatus[selectedRow] === "uploaded" ? (
                                <Box
                                  sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                  }}
                                >
                                  <Tooltip title={"Save Proof"}>
                                    <IconButton
                                      sx={{ color: "primary" }}
                                      onClick={() =>
                                        handleSaveDocs(selectedRow, files)
                                      }
                                    >
                                      <CheckCircleIcon color="primary" />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title={"Deselect Proof"}>
                                    <IconButton
                                      sx={{ color: "grey.500" }}
                                      onClick={() =>
                                        handleDeselectFile(selectedRow)
                                      }
                                    >
                                      <CancelIcon />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              ) : null}
                            </>
                          )}
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleView(fileProof[selectedRow])}
                          disabled={!fileProof[selectedRow] || !toggleState}
                        >
                          <Tooltip
                            title={
                              !toggleState
                                ? ""
                                : !fileProof[selectedRow]
                                ? "No Attachment"
                                : "View Attachment"
                            }
                          >
                            <Box display="flex" alignItems="center" gap={0.5}>
                              <VisibilityIcon sx={{ mr: 1 }} />
                              <Typography sx={{ fontSize: "0.9rem" }}>
                                {!fileProof[selectedRow]
                                  ? "No Attachment"
                                  : "View Attachment"}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </MenuItem>
                      </Menu>
                    </Box>

                    <Box width={"30%"}>
                      <TextareaAutosize
                        minRows={2}
                        maxRows={3}
                        disabled={!checkViewType}
                        placeholder={
                          checkViewType ? "Enter Comment" : "Comment"
                        }
                        value={comments?.[data?.name] || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 75) {
                            setComments({
                              ...comments,
                              [data?.name]: value,
                            });
                          }
                        }}
                        style={{
                          width: "100%",
                          backgroundColor: checkViewType
                            ? "#ffffff"
                            : "transparent",
                          borderRadius: "10px",
                          padding: "8px",
                          fontSize: "14px",
                          fontFamily: "inherit",
                          border: "1px solid #ccc",
                          resize: "none",
                        }}
                      />
                      {checkViewType && (
                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            textAlign: "right",
                            color: "#888",
                          }}
                        >
                          {comments?.[data?.name]?.length || 0}/75
                        </Typography>
                      )}
                    </Box>
                  </Paper>
                </Grid>
              ) : (
                disableEdit &&
                step2?.[data?.name] !== null &&
                step2?.[data?.name] !== undefined &&
                step2?.[data?.name] !== "" && (
                  <Grid item key={id} xs={12} sm={6} md={6} padding={1.5}>
                    <Paper className={classes.paper}>
                      <Box sx={{ minHeight: "4rem", width: "75%" }}>
                        <Typography variant="body2" gutterBottom mb={2}>
                          {data?.desc}
                        </Typography>
                      </Box>
                      <Box width={"25%"}>
                        <TextField
                          size="small"
                          autoComplete="first_name"
                          onChange={handleChange}
                          name={data?.name}
                          label={data?.label}
                          disabled={true}
                          placeholder="Enter Amount"
                          fullWidth
                          value={step2?.[data?.name] || ""}
                          type="number"
                        />
                      </Box>
                    </Paper>
                  </Grid>
                )
              )}
            </>
          );
        })}
      </Grid>
      {!disableEdit && (
        <Grid
          item
          width={"100%"}
          sx={{ padding: "4px 8px", marginBottom: "4px" }}
        >
          <Paper className={classes.paper} sx={{ height: "60px" }}>
            <Box width={"60%"} display={"flex"} alignItems={"center"}>
              <Typography variant="h6">Total</Typography>
            </Box>
            <Box width={"15%"} pr={1}>
              <TextField
                size="small"
                disabled
                placeholder="Total"
                fullWidth
                label="Declared"
                value={Number(calculateTotal()).toLocaleString("en-IN") || "0000"}
                type="text"
                sx={{
                  "& .MuiInputBase-input": {
                    fontWeight: "600",
                  },
                }}
              />
            </Box>
            {(checkViewType || show) && (
              <Box width={"15%"}>
                <TextField
                  size="small"
                  disabled
                  placeholder="Total"
                  label="Approved"
                  value={Number(calculateTotal2()).toLocaleString("en-IN") || "0000"}
                  type="text"
                  sx={{
                    "& .MuiInputBase-input": {
                      fontWeight: "600",
                    },
                  }}
                />
              </Box>
            )}
            <Box
              width={"10%"}
              display="flex"
              justifyContent={"space-around"}
            ></Box>
            <Box width={"30%"}></Box>
          </Paper>
        </Grid>
      )}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {activeStep !== 0 && !disableEdit && (
          <Button
            sx={{ marginRight: "10px", mt: 3 }}
            type="submit"
            variant="contained"
            className="mpl-primary-btn"
            size="medium"
            onClick={() => setActiveStep(activeStep - 1)}
          >
            Back
          </Button>
        )}
        {activeStep < 5 && (
          <Button
            sx={{ marginRight: "10px", mt: 3 }}
            size="medium"
            variant="contained"
            className="mpl-primary-btn"
            onClick={() => handleSubmit()}
          >
            Next
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default TDStep2;
